import OptionToggle from "~/components/OptionToggle";
import React from "react";
import {useFeatures} from "~/lib/Features";

const DisableWaitlistSetting = ({ settings, setSettings, className }) => {
    const {isEnabled} = useFeatures();

    if (!isEnabled('waitlist')) {
        return null;
    }

    return (
        <div className={className}>
            <OptionToggle
                value={!settings?.disableWaitlist}
                onChange={value =>
                    setSettings({...settings, disableWaitlist: !value})
                }
                title="Enable Waitlist"
                description="Allow clients to sign up for a waitlist if their time is full"
            />
        </div>
    )
}

export default DisableWaitlistSetting;
